// What a price book service uses, as zod (pages/ux-full components/setup.js ItemUses): pricebook.getItem's
// materials[] and details as they are. Not in TOOL_VIEWS yet.
import { z } from 'zod';

/** One thing a service puts in: a price book part or piece of equipment, and how many. */
export const ItemUse = z.object({
  itemId: z.string().min(1),
  code: z.string(),
  name: z.string(),
  type: z.enum(['service', 'material', 'equipment']),
  unit: z.string(),
  /** "2.000": thousandths, as the database keeps it */
  quantity: z.string(),
  active: z.boolean(),
  /** Only for those who see our cost (pricebook.cost.view): absent otherwise. */
  costCents: z.int().nullable().optional(),
});
export type ItemUse = z.infer<typeof ItemUse>;

/** What an item carries beyond its price: its sold hours, add-on price and warranty. */
export const ItemTerms = z.object({
  /** "4.00" */
  soldHours: z.string().nullable(),
  warrantyText: z.string().nullable(),
  addOnPriceCents: z.int().nullable(),
  addOnMemberPriceCents: z.int().nullable(),
});
export type ItemTerms = z.infer<typeof ItemTerms>;

/** pricebook.getItem's materials and details. */
export const ItemUsesProps = z.object({ uses: z.array(ItemUse), details: ItemTerms.nullable() });
export type ItemUsesProps = z.infer<typeof ItemUsesProps>;
